import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { CheckboxOptionCard, RegionsSelector, Text } from '@reveni-io/reveni-ui'

import { groupRegionsByContinent } from '@/common/helpers/helpers'
import AdditionalCriteriaSelector from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/components/AdditionalCriteriaSelector/AdditionalCriteriaSelector'
import configurationServices from '@/configuration/services/services'

import { errorTypes } from '../constants'
import { getVisibleEnabledForCards } from '../helpers'
import SectionHeader from '../SectionHeader/SectionHeader'
import * as SharedStyles from '../styles'
import {
  getEnabledForPayload,
  getRegionErrorMessage,
  getRegionErrorType,
  getSelectedValues,
  getToggledEnabledForValues,
} from './helpers'
import * as Styles from './styles'

const AvailabilitySection = ({ config, regions, errors, onChange, disabled, allowsUnifiedFlow, storeId }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const selectedValues = getSelectedValues({
    enabledForRefunds: config?.enabled_for_refunds,
    enabledForExchanges: config?.enabled_for_exchanges,
    enabledForMixed: config?.enabled_for_mixed,
  })
  const visibleCards = getVisibleEnabledForCards(allowsUnifiedFlow)
  const showEnabledForError = !!errors?.find(error => error.type === errorTypes.allowedEmpty)
  const regionErrorType = getRegionErrorType(errors)
  const regionErrorMessage = getRegionErrorMessage(errors, config?.regions, t)

  const handleToggleEnabledFor = (value, checked) => {
    onChange(getEnabledForPayload(getToggledEnabledForValues({ value, checked, selectedValues })))
  }

  const handleChangeRegions = regions => onChange({ regions })

  return (
    <Styles.Container>
      <SectionHeader
        title={t('Disponibilidad')}
        description={t('Este método estará disponible en el portal para los siguientes tipos de solicitud')}
      />
      <div id={errorTypes.allowedEmpty}>
        <SharedStyles.CardsGrid columns={3}>
          {visibleCards.map(card => {
            return (
              <CheckboxOptionCard
                key={card.value}
                icon={<card.Icon size={24} weight="thin" />}
                title={t(card.title)}
                description={t(card.description)}
                name={card.value}
                selected={selectedValues.includes(card.value)}
                disabled={disabled}
                onChange={checked => handleToggleEnabledFor(card.value, checked)}
              />
            )
          })}
        </SharedStyles.CardsGrid>
      </div>
      {showEnabledForError && (
        <Text type="bodySRegular" color={theme.colors.danger.default}>
          {t('Al menos un tipo de solicitud debe estar seleccionado')}
        </Text>
      )}
      <Text type="bodyMRegular">
        {t('Este método estará disponible en el portal para las solicitudes realizadas desde las siguientes regiones')}
      </Text>
      <div id={regionErrorType}>
        <RegionsSelector
          label={t('Disponible en')}
          regions={groupRegionsByContinent(regions)}
          value={config?.regions}
          onChange={handleChangeRegions}
          helperText={regionErrorMessage}
          error={regionErrorType}
          inputBackgroundColor={theme.colors.background.secondary}
          disabled={disabled}
        />
      </div>
      <AdditionalCriteriaSelector
        storeId={storeId}
        selectedCriterionIds={config?.availability_criterion_ids}
        onChange={onChange}
        getCriteriaService={configurationServices.getAvailabilityCriteria}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default AvailabilitySection
